import Store from 'store/store';
import * as actions from 'store/actions';
import {
	getGeoScreeningsAsync,
	getCitiesAsync,
	getTheatersScreeningsAsync } from 'utils/clientUtils';
import processScreeningsApi from 'utils/processScreeningsApi';
import { track } from 'utils/tracking';
import { accessNested, asList, parseDate } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';
import queryString from 'qs';
import { filterTheater } from 'models/Theater';
import City from 'models/City';

/* Theaters
--------------------------------*/

Store.on(actions.SET_THEATERS, theaters => {
	let showtimesState = Store.get().showtimes;
	// Not sure why we make a copy of the theaters but I'm scared to remove it
	let total = (theaters || []).map(t => Object.assign({}, t));
	// Make sure we are using objects and not instances
	showtimesState.set({ theaters: total, firstDataLoaded: true, loading: false });
	Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS, theaters && theaters.map(t => t.id));
	if (!showtimesState.firstDataLoaded) Store.emit(actions.FIRST_DATA_LOADED);
});


Store.on(actions.ADD_THEATERS, (newTheaters) => {
	let showtimesState = Store.get().showtimes;
	// Breaks the thing
	if (showtimesState.loading || showtimesState.error) return;
	let theaters = showtimesState.theaters || [];
	newTheaters = newTheaters.filter(nt => !theaters.find(t => t.id === nt.id));

	if (!newTheaters.length) return;
	Store.emit(actions.SET_THEATERS, theaters.concat(newTheaters), true);
});


Store.on(actions.SELECT_THEATER, (theaterId) => {
	let state = Store.get();
	let theaters = state.showtimes.theaters;
	if (!theaters) return;
	let currentActive = theaters.find(t => t.active);
	if (currentActive) currentActive.set({ active: false });
	let newActive = theaterId && theaters.find(t => t.id === theaterId);
	if (newActive) {
		newActive.set({ active: true });
		try {
			window.localStorage.setItem(state.appData.meta.id + '_lastHouse', newActive.geo.toString());
		} catch(e) { }
	}
	track({ a: 'list_click', l: theaterId, useCustomPageTrack: true });
});

Store.on(actions.SELECT_MACCS_THEATER, (theaterId) => {
	track({ a: 'SELECT_MACCS_THEATER', l: theaterId });
});

Store.on(actions.VISIBLE_MACCS_THEATER, (theaterId) => {
	track({ a: 'VISIBLE_MACCS_THEATER', l: theaterId });
});

Store.on(actions.SET_THEATER_STATE, (theater, state, data) => {
	if (!theater) return;
	theater.set({ state: state, stateData: data });
});


Store.on(actions.UPDATE_THEATER_FILTERED_SCREENINGS, (newIds) => {
	let state = Store.get();
	let showtimesState = state.showtimes;

	let sortTheatersByDate = accessNested(state, 'appData.options.sortTheatersByDate');
	// Copy them to be able to sort them
	// let theaters = showtimesState.theaters.map(t => Object.assign({}, t));
	let theaters = showtimesState.theaters.toJS();
	let filters = showtimesState.filters;

	if (theaters) {
		theaters.forEach(t => Object.assign(t, filterTheater(t, filters)));
		// let pinned = asList(accessNested(state, 'activePage.data.pinnedTheaters'));
		// let isPinned = (t) => pinned.indexOf(t && t.id) !== -1;
		let compProp = 'distance', undefinedFirst = false;
		if (sortTheatersByDate) {
			compProp = 'firstDate';
		}
		if (showtimesState.sortBy) {
			compProp = showtimesState.sortBy;
		}
		let compare = (a, b, p, undefinedFirst) => {
			let aPinned = a.pinned, bPinned = b.pinned;
			if (aPinned !== bPinned) return aPinned ? -1 : 1;
			let va = a[p], vb = b[p];
			// == and not === to also check null
			if (va == vb) {
				// Always end up sorting equivalent theaters by distance
				return p !== 'distance' ? compare(a, b, 'distance', false) : 0;
			}
			if (va == undefined) return undefinedFirst ? -1 : 1;
			if (vb == undefined) return undefinedFirst ? 1 : -1;
			let compareAsString = typeof a === 'string' && typeof b === 'string' && (isNaN(a) || isNaN(b));
			return compareAsString ? a.localeCompare(b) : va - vb; // ASC (should we make that an option ?)
		};
		// Theaters with unfiltered screenings first, then by distance (or date)
		let sortFunc = (a,b) => (!!b.filteredScreenings.length - !!a.filteredScreenings.length) || compare(a, b, compProp, undefinedFirst);
		theaters.sort(sortFunc);
		let currentActive = theaters.find(t => t.active && t.enabled);
		if (!currentActive) {
			let first = theaters.find(t => t.enabled && (!newIds || newIds.indexOf(t.id) !== -1) && t.filterPass && t.activeExhibitor);
			if (first) {
				// Store.emit(actions.SELECT_FIRST_THEATER, first);
				// track({a: 'list_click', l: first.id, ni: 1});
				first.active = true;
				const isMACCS = first.screenings.some(screening => screening.provider_id === 'maccs') ;
				if (isMACCS) {
					Store.emit(actions.VISIBLE_MACCS_THEATER, first.id);
				}
				// Update last house ?
				// try {
				// 	window.localStorage.setItem(state.appData.meta.id + '_lastHouse', first.geo.toString());
				// } catch(e) { }
			}
		}
	}
	// showtimesState.set({theaters});
	Store.get().showtimes.set({ theaters }).now();
	Store.emit(actions.AFTER_THEATERS_UPDATE);
});


/* Map
--------------------------------*/

Store.on(actions.SET_MAP_OPEN, (open) => {
	let showtimesState = Store.get().showtimes;
	showtimesState.set({ mapOpen: open });
	document.body.style.overflow = open ? 'hidden' : 'visible';
});


/* Cities
--------------------------------*/

Store.on(actions.SET_CITIES, (cities) => {
	Store.get().showtimes.set({ cities, cityShowCount: 10 });
});

Store.on(actions.SET_CITY_SHOW_COUNT, (cityShowCount) => {
	Store.get().showtimes.set({ cityShowCount });
});


/* Filters
--------------------------------*/

// TODO: WE SHOULD HAVE DIFFERENT SUBOBJECT IN THE STORE FOR EACH PAGE
// Instead of just a "showtimes" prop

// Make sure filters are what they need to be on the current page
Store.on(actions.CHECK_FILTERS, (noRefresh) => {
	let state = Store.get();
	let filters = state.showtimes.filters;

	let hiddenFilters = accessNested(state, 'activePage.data.hiddenFilters', {});

	filters.timeOfDay.set({ visible: !hiddenFilters.time });
	// Should we reset current ? I guess so
	filters.stDate.set({ visible: !hiddenFilters.date, current: [] });
	if (hiddenFilters.format) filters.format.set({ visible: false });
	filters.hour.set({ current: [] });


	let disabledFilters = accessNested(state, 'activePage.data.disabledFilters');
	if (disabledFilters) {
		let disabledFormats = asList(disabledFilters.format);
		if (disabledFormats) {
			let options = disabledFormats.map(k => ({ slug: k.toLowerCase().replace(/\s+/g, '') }));
			Store.emit(actions.FILTER_DISABLE, 'format', options, true);
		}

		let disabledExhib = disabledFilters.exhibitor;
		if (disabledExhib) {
			let options = asList(disabledExhib).map(dom => ({ domain: dom }));
			Store.emit(actions.FILTER_EXCLUDE, 'exhibitor', options, true);
		}

		let disabledWebediaTheater = disabledFilters.webediaTheater;
		if (disabledWebediaTheater) {
			// let allTheaters = state.showtimes.theaters || [];
			// let desired = asList(disabledWebediaTheater);
			// let providers = ['wwm', 'webus', 'webuk'];
			// TODO: also check providerId
			// let options = allTheaters.filter(t => desired.indexOf(t.providerTheaterId) !== -1);
			// console.log('?', options, desired, state.showtimes);
			let options = asList(disabledWebediaTheater).map(id => ({providerTheaterId: id}));
			Store.emit(actions.FILTER_EXCLUDE, 'webedia', options, true);
		}

		let disabledTheater = disabledFilters.theater;
		if (disabledTheater) {
			let options = asList(disabledTheater).map(id => ({ id: id }));
			Store.emit(actions.FILTER_EXCLUDE, 'theater', options, true);
		}
	}

	let defaultFilters = accessNested(state, 'activePage.data.defaultFilters');

	if (defaultFilters) {
		let defaultDate = defaultFilters.date;
		if (defaultDate) {
			let active = true;
			let datesList = filters.stDate.options;
			if (typeof defaultDate === 'object') {
				if (defaultDate.from) {
					let from = parseDate(defaultDate.from);
					if (from) datesList = datesList.filter(d => d.date >= from);
				}
				if (defaultDate.to) {
					let to = parseDate(defaultDate.to);
					if (to && to < Date.now()) active = false;
					if (to) datesList = datesList.filter(d => d.date <= to);
				}
				if ((defaultDate.from || defaultDate.to) && !datesList.length) {
					if (defaultDate.from && defaultDate.to) {
						let date1 = parseDate(defaultDate.from);
						let date2 = parseDate(defaultDate.to);
						let from = Math.min(date1, date2);
						let to = Math.max(date1, date2);
						let currentDate = new Date(from);
						datesList = [];
						while (currentDate <= to) {
							datesList.push({ id: +currentDate });
							currentDate.setDate(currentDate.getDate() + 1);
						}
					} else {
						let desired = parseDate(defaultDate.from || defaultDate.to);
						if (desired) datesList = [{ id: +desired }];
					}
				}
			} else {
				let desired = parseDate(defaultDate);
				// if(desired) datesList = datesList.filter(d => {
				// 	return +d.date === +desired;
				// });
				if (desired && desired < Date.now()) active = false;
				if (desired) datesList = [{ id: +desired }];
			}
			if (active) {
				Store.emit(actions.TOGGLE_FILTER, 'stDate', datesList, true);
				Store.emit(actions.SET_FILTER_VISIBILITY, 'stDate', !!defaultDate.visible);
			}
		}

		let defaultHour = defaultFilters.hour;
		if (defaultHour) {
			let options = [];
			if (typeof defaultHour === 'object') {
				let from = +defaultHour.from || 0, to = 24;
				if (defaultHour.to && !isNaN(+defaultHour.to)) to = +defaultHour.to;
				if (to < from) { let tmp = to; to = from; from = tmp; }
				for (let i = from; i <= to; i++) {
					options.push({ id: i });
				}
			} else {
				options = [{ id: +defaultHour }];
			}
			Store.emit(actions.TOGGLE_FILTER, 'hour', options, true);
		}
		let defaultMinute = defaultFilters.minute;
		if (defaultMinute) {
			let options = [];
			if (typeof defaultMinute === 'object') {
				let from = +defaultMinute.from || 0, to = 60;
				if (defaultMinute.to && !isNaN(+defaultMinute.to)) to = +defaultMinute.to;
				if (to < from) { let tmp = to; to = from; from = tmp; }
				for (let i = from; i <= to; i++) {
					options.push({ id: i });
				}
			} else {
				options = [{ id: +defaultMinute }];
			}
			Store.emit(actions.TOGGLE_FILTER, 'minute', options, true);
		}

		let defaultFormat = defaultFilters.format;
		if (defaultFormat) {
			let options = asList(defaultFormat).map(format => ({ slug: format.toLowerCase().replace(/\s/g, '') }));
			Store.emit(actions.TOGGLE_FILTER, 'format', options, true);
		}

		let defaultExhib = defaultFilters.exhibitor;
		if (defaultExhib) {
			let options = asList(defaultExhib).map(dom => ({ domain: dom }));
			Store.emit(actions.TOGGLE_FILTER, 'exhibitor', options, true);
		}

		let defaultTheater = defaultFilters.theater;
		if (defaultTheater) {
			let options = asList(defaultTheater).map(id => ({ id: id }));
			Store.emit(actions.TOGGLE_FILTER, 'theater', options, true);
		}

		if (defaultFilters.pidmod) {
			// Reset the cities filter to
			//NOTE: this should be probably be done somewhere else, but it needs to work with multiple showtimes pages
			state.showtimes.citiesFilters.set({
				pidmod: defaultFilters.pidmod
			});

			if (state.client.geo) {
				// Only reload cities if geo has actually been set
				Store.emit(actions.SCREENINGS_LOADED);
			}
		}
	}


	if (state.showtimes.citiesFilters && state.showtimes.citiesFilters.pidmod && (!defaultFilters || !defaultFilters.pidmod)) {
		// Remove the pidmod again from the state because we don't have a set
		// default filter
		state.showtimes.citiesFilters.set({
			pidmod: null
		});

		// Reset cities with the new pidmod
		Store.emit(actions.SCREENINGS_LOADED);
	}

	if (typeof document !== 'undefined') {
		let qs = queryString.parse(document.location.search.slice(1));
		if (qs.format || qs.reald) {
			// Formats coming fron the Query String
			const desiredFormat = (qs.format || '').toLowerCase().split(',');
			// Formats that are available through the api
			let srcOptions = filters.format.options;
			let options = [];
			// Even when the desired format isn't available,
			// still filter on it
			if (state.appData.options.formatFilterIsStrict) {
				options = srcOptions.filter(f => desiredFormat.indexOf(f.slug) !== -1);
			} else {
				options = srcOptions.filter(f => desiredFormat.find(df => f.slug.replace(/&/g, '').indexOf(df) !== -1));
			}
			if (qs.reald) {
				let newOptions = srcOptions
					.filter(f => f.slug.indexOf('imax') === -1 && f.slug.match(/(reald\s*)?\b3d\b/i))
					.map(option => Object.assign({ reald: true }, option));
				options = options.concat(newOptions);
			}
			if (!options.length) {
				if (qs.reald) {
					options = [{ slug: 'reald3d', label: 'RealD 3D', reald: true }];
				} else {
					// The desired format doesn't exist in the existing options
					options = desiredFormat.map(f => ({ slug: f, label: f }));
					// Make the format filter visible,
					// so people can disable it again
					Store.emit(actions.SET_FILTER_VISIBILITY, 'format', true);
				}
			}
			Store.emit(actions.TOGGLE_FILTER, 'format', options, true);
		}
		if (qs.exhibitor) {
			let desiredExhib = qs.exhibitor.toLowerCase().replace(/^https?:\/\/(www\.)?/, '');
			// Store.emit(actions.TOGGLE_FILTER, 'exhibitor', filters.exhibitor.options.filter(e => e.domain.toLowerCase().indexOf(desiredExhib) !== -1), true);
			Store.emit(actions.TOGGLE_FILTER, 'exhibitor', [{ domain: desiredExhib }], true);
			Store.emit(actions.SET_FILTER_VISIBILITY, 'exhibitor', true);
		}
		if (qs.provider) {
			// let desired = qs.provider.split(',').map(e => ({id: e, name: e}));
			let desired = qs.provider.split(',');
			let result = filters.ticketProvider.options.filter(e => desired.indexOf(e.id) !== -1);
			Store.emit(actions.TOGGLE_FILTER, 'ticketProvider', result, true);
			Store.emit(actions.SET_FILTER_VISIBILITY, 'ticketProvider', true);
		}
		if (qs.date) {
			let arr = qs.date.split(',');
			let options = filters.stDate.options.filter(e => {
				let ddmmyyyy = e.ddmmyyyy;
				let std = formatDateTime(e.date, 'yyyy-MM-dd');
				return arr.find(desired => desired === ddmmyyyy || desired === std);
			});
			if (!options.length) {
				options = arr.map(elem => ({ id: +parseDate(elem) }));
			}
			Store.emit(actions.TOGGLE_FILTER, 'stDate', options, true);
		}
		if (qs.timeofday) {
			let arr = qs.timeofday.toUpperCase().split(',');
			Store.emit(actions.TOGGLE_FILTER, 'timeOfDay', filters.timeOfDay.options.filter(e => arr.indexOf(e.id.slice(1)) !== -1), true);
		}
		if (qs.title) {
			let desired = qs.title.toLowerCase().split(',');
			// let comp = m => desired.indexOf(m.slug) !== -1; // exact match
			let comp = m => desired.find(d => m.slug.indexOf(d) !== -1); // contains
			let options = filters.movie.options.filter(comp);
			if (!options.length) {
				options = desired.map(e => ({ slug: e, title: e }));
			}
			Store.emit(actions.TOGGLE_FILTER, 'movie', options, true);
		}
	}

	if (!noRefresh) Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS);
});


Store.on(actions.RELOAD_FILTERS, (data, keepCurrent) => {
	if (!data) {
		// No data specified, reload the filters based on the existing showtimes data
		let store = Store.get();
		let theaters = store.showtimes.theaters || [];
		let screenings = [];
		let exhibitors = {};
		let movies = {};
		let formats = {};
		theaters.forEach(theater => {
			screenings.push(theater.screenings);
			if (theater.exhibitor) {
				exhibitors[theater.exhibitor.id] = theater.exhibitor;
			}
			theater.movies.forEach(movie => {
				movies[movie.id] = movie;
				if (movie.format) {
					formats[movie.format.id] = movie.format;
				}
			});
		});
		exhibitors = Object.values(exhibitors);
		movies = Object.values(movies);
		formats = Object.values(formats);
		data = { theaters, screenings, exhibitors, movies, formats };
	}

	let { theaters, exhibitors, movies=[], formats=[] } = data;
	let timeOfDayOptions = [];
	let stDateOptions = [];
	let ticketProviders = [];
	// let blockedExhibitors = accessNested(state, 'appData.pageData.showtimes.blockedExhibitors', []);
	let state = Store.get();
	let filters = state.showtimes.filters;
	let screeningsMovieIds = [];
	// Use the theaters screenings rather than the list of all screenings to not get the ones removed by the provider merging
	theaters.forEach(t => t.screenings.forEach(s => {
		// Only add it if it is supposed to be displayed
		if (s.timeOfDay && s.timeOfDay.label && timeOfDayOptions.indexOf(s.timeOfDay) === -1) {
			timeOfDayOptions.push(s.timeOfDay);
		}
		if (s.stDate && stDateOptions.indexOf(s.stDate) === -1) {
			stDateOptions.push(s.stDate);
		}
		if (screeningsMovieIds.indexOf(s.movie.id) === -1) {
			screeningsMovieIds.push(s.movie.id);
		}
		let sTicketProviders = s.urls ? Object.keys(s.urls) : [];
		sTicketProviders.forEach(tp => ticketProviders.indexOf(tp) === -1 && ticketProviders.push(tp));
	}));
	movies = movies.filter(m => screeningsMovieIds.includes(m.id)).sort((a, b) => {
		// TODO option to have custom order in thundr
		return a.title.localeCompare(b.title);
	});
	const timeOfDayOrder = ['$MORNING', '$AFTERNOON', '$EVENING', '$LATE'];
	// timeOfDayOptions.sort((a, b) => timeOfDayOrder.indexOf(a.id) - timeOfDayOrder.indexOf(b.id));

	// reverse order to easily put the unknow formats at the end of the list
	let formatOrder = ['imax 3d', '3d imax', 'imax 70mm', 'imax 2d', '2d imax', 'imax', 'dolby cinema', 'dolby', '3d', '70mm', '35mm', '2d'].reverse();
	let disabledFormats = asList(accessNested(state, 'activePage.data.disabledFilters.format', {})).map(e => e.toLowerCase().replace(/\s+/g, ''));
	formats = formats.filter(f => f && disabledFormats.indexOf(f.slug) === -1).sort((a, b) => {
		let nameA = a.name.toLowerCase();
		let nameB = b.name.toLowerCase();
		let detectedOrder = formatOrder.indexOf(nameB) - formatOrder.indexOf(nameA);
		return detectedOrder || nameA.localeCompare(nameB);
	});

	filters.timeOfDay.set({
		options: timeOfDayOptions.sort((a, b) => timeOfDayOrder.indexOf(a.id) - timeOfDayOrder.indexOf(b.id))
	});
	filters.stDate.set({
		options: stDateOptions.sort((a, b) => a.date - b.date)
	});
	filters.exhibitor.set({
		options: exhibitors.filter(exhib => exhib.domain)
	});
	let options = accessNested(state, 'appData.options') || {};
	let showMovieFilter = options.useTitleFilter || options.useTitleFilterLegacy;
	filters.movie.set({
		options: movies,
		visible: showMovieFilter && movies.length > 1
	});
	filters.format.set({
		options: formats,
		visible: options.useFormatFilter && formats.length > 1
	});
	let providerNames = { // TODO copy or something ?
		fandango: 'Fandango',
		atom: 'Atom',
		movietickets: 'Movie Tickets',
		cinema: 'Direct to cinema',
	};
	filters.ticketProvider.set({
		options: ticketProviders.map(tp => ({ id: tp, name: providerNames[tp] || tp }))
	});
	if (!keepCurrent) {
		filters = Store.get().showtimes.filters;
		['timeOfDay', 'stDate', 'exhibitor', 'movie', 'format', 'ticketProvider'].forEach(filter => filters[filter].set({
			current: [],
			disabled: []
		}));
	}
	// var excludedList = [];
	// blockedExhibitors.forEach(ex => {
	// 	if(!ex) return;
	// 	ex = ex.toLowerCase();
	// 	var match = exhibitors.find(e => e.domain.toLowerCase() === ex);
	// 	if(match && excludedList.indexOf(match) === -1)
	// 		excludedList.push(match);
	// });
	// Store.emit(actions.FILTER_EXCLUDE, 'exhibitor', excludedList, true);

	Store.emit(actions.CHECK_FILTERS);
	// Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS);
});

Store.on(actions.TOGGLE_FILTER, (id, options, preventReload) => {
	let storeFilter = Store.get().showtimes.filters[id];
	if (!storeFilter) return;
	if (!options) options = [];
	if (!Array.isArray(options)) options = [options];
	storeFilter.set({ current: options });
	if (!preventReload) {
		Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS);
	}
});

Store.on(actions.FILTER_EXCLUDE, (id, options, preventReload) => {
	let storeFilter = Store.get().showtimes.filters[id];
	if (!storeFilter) return;
	if (!options) options = [];
	if (!Array.isArray(options)) options = [options];
	storeFilter.set({ excluded: options });
	if (!preventReload) {
		Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS);
	}
});

Store.on(actions.FILTER_DISABLE, (id, options, preventReload) => {
	let storeFilter = Store.get().showtimes.filters[id];
	if (!storeFilter) return;
	if (!options) options = [];
	if (!Array.isArray(options)) options = [options];
	storeFilter.set({ disabled: options });
	if (!preventReload) {
		Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS);
	}
});

Store.on(actions.SET_FILTER_VISIBILITY, (id, visible) => {
	let storeFilter = Store.get().showtimes.filters[id];
	if (!storeFilter) return;
	storeFilter.set({ visible: !!visible });
	// if(!preventReload)
	// 	Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS);
});


Store.on(actions.SELECT_ST_DATE, (stDate) => {
	Store.get().showtimes.set({ selectedDate: stDate });
	track({ a: 'date_click', l: stDate.ddmmyyyy, useCustomPageTrack: true });
});


Store.on(actions.SELECT_PROVIDER, (provider) => {
	Store.get().showtimes.set({provider});
});


Store.on(actions.RESET_FILTER, (id) => {
	Store.get().showtimes.filters[id].set({current: []});
	Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS);
});


Store.on(actions.RESET_FILTERS, () => {
	let showtimesState = Store.get().showtimes;
	Object.keys(showtimesState.filters).forEach(key => showtimesState.filters[key].set({current: []}));
	Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS);
});


/* Screenings
--------------------------------*/

let thMasters = {};
Store.on(actions.GET_SCREENINGS, (geo, keepCurrentFilters) => {
	if (!geo) {
		geo = accessNested(Store.get(), 'client.geo');
	}
	if (!geo) return;

	let state = Store.get();
	let isFirstBatch = !state.showtimes.theaters || !state.showtimes.theaters.length;

	let version = Date.now();
	let loadingPage = accessNested(state, 'activePage.id') || 'showtimes';
	let activePage = accessNested(state, ['appData', 'pages', loadingPage]);
	let activePageFallback = activePage || {};
	let isShowtimesPage = loadingPage === 'showtimes' || activePageFallback.compName === 'showtimes';
	let isShowtimesBase = !activePageFallback.base || activePageFallback.base === 'showtimes';
	// TODO: non-showtimes bases: only if an option (e.g. Pages > page > fetchShowtimes) is enabled
	if (isShowtimesBase && !isShowtimesPage) {
		return;
	}
	state.showtimes.set({ loading: true, error: null, cities: [], theaters: [], version, loadingPage }).now();
	thMasters = {};
	return getGeoScreeningsAsync(geo, Store.get()).then(data => {
		let store = Store.get();
		if (store.showtimes.version !== version) throw 'version';
		if (data.errors && data.errors.length) {
			throw new Error('screenings:' + data.errors[0].detail);
		}
		if (!data.data) {
			// throw new Error('NO_DATA');
			data.data = [];
		}

		return processScreeningsApi(data, geo, store.appData, activePage, thMasters, isFirstBatch);
	}).then(all => {
		let state = Store.get();
		if (state.showtimes.version !== version) throw 'version';
		let pinned = asList(accessNested(state, 'activePage.data.pinnedTheaters')).filter(id => !all.theaters.find(t => t.id === id));
		if (pinned.length) {
			// Store.emit(actions.EXTRA_THEATERS, pinned);
			return getTheatersScreeningsAsync(state, pinned).then(data => {
				if (data.errors && data.errors.length || !data.data) return all;
				let processedPinned = processScreeningsApi(data, geo, Store.get().appData, activePage, thMasters, isFirstBatch);
				let allKeys = Object.keys(all);
				allKeys.forEach(k => {
					if(Array.isArray(all[k]) && processedPinned[k]) {
						all[k] = all[k].concat(processedPinned[k]);
					}
				});
				Object.keys(processedPinned).filter(k => allKeys.indexOf(k) === -1).forEach(k => all[k] = processedPinned[k]);
				return all;
			});
		}
		return all;
	}).then(({ formats, movies, screenings, exhibitors, theaters }) => {
		let state = Store.get();
		if (state.showtimes.version !== version) throw 'version';
		// if(!theaters.length && toCapital()) return;
		exhibitors = (exhibitors || []).filter(e => theaters.find(t => t.exhibitor === e));
		Store.emit(actions.RELOAD_FILTERS, { theaters, screenings, exhibitors, movies, formats }, keepCurrentFilters);
		Store.emit(actions.SET_THEATERS, theaters, null, geo);
		Store.emit(actions.SCREENINGS_LOADED, geo);
	}).catch(err => {
		if (err === 'version') return;
		console.log('GET_SCREENINGS error', err);
		Store.emit(actions.API_ERROR, 'StData', err);
		// if (toCapital()) return;
		Store.emit(actions.RESET_FILTERS);
		Store.emit(actions.SET_THEATERS, [], err, geo);
		let store = Store.get();
		if (store.client.geo !== geo) {
			return;
		}
		let errCode = 'UNKNOWN';
		switch (err) {
			case 'BOUNDING_REGION':
				errCode = 'BOUNDING_REGION';
				if (store.client.geo) {
					// Find cities in the current country
					Store.emit(actions.SCREENINGS_LOADED, geo, accessNested(store, 'appData.meta.region.slug'));
				}
				break;
			default:
				// console.log("showtimes_request_error", err);
				track({ a: 'showtimes_request_error', l: err.message, ni: 1 });
		}
		// Store.emit(actions.SET_THEATERS, []);
		Store.get().showtimes.set({ loading: false, error: errCode });
	});
});

Store.on(actions.SCREENINGS_LOADED, (geo, overrideCountry) => {
	let state = Store.get();
	let citiesProps = { ...state };
	if (overrideCountry) {
		citiesProps.overrideCountry = overrideCountry;
		// Nah let's not do that, makes client.geo wrong
		// geo.countryCode = overrideCountry;
	}

	if (!geo) {
		// If no geo is set, grab the current one from the store
		geo = state.client.geo;
	}

	getCitiesAsync(citiesProps)
		.then((data) => {
			if (data.errors && data.errors.length) {
				throw new Error(data.errors[0].detail);
			}
			if (!data.data) {
				// throw new Error(NO_DATA);
			}
			return data;
		})
		.catch((err) => {
			track({ a: 'cities_request_error', l: err.message, ni: 1 });
			console.log("cities_request_error", err);
			Store.emit(actions.API_ERROR, 'StData', err);
		})
		.then((res) => {
			if (!res) return; //if no response then escape
			let data = res.data || [];

			// let cities = data.data.map((c)=>(new City(c.attributes, geo, state.appData.copy)));
			let cities = [];
			let citiesCache = {};
			let copy = accessNested(state, 'appData.copy') || {};
			let useEnglishCopy = accessNested(state, 'appData.options.useEnglishCopy');
			data.forEach(c => {
				// For the US (2000 cities) we were iterating 4 million times (complexity close to O(n²), because for every city we are using `find` on the others).
				// Even if we don't check the distance for all of them, it takes some time to go through
				// Using a cache makes it (basically) O(n).
				// 2000 cities = 4892.872ms (using find) -> 16.420ms (using cache)
				// Results are the same, it just uses more memory while working (but that should be garbage collected afterwards)
				if (!c.attributes.country && overrideCountry) {
					c.attributes.country = overrideCountry;
				}
				let newCity = new City(c.attributes, geo, copy, useEnglishCopy);
				let append = true;
				let key = newCity.name;
				// eslint-disable-next-line no-prototype-builtins
				if (citiesCache.hasOwnProperty(key)) {
					let cachedCities = citiesCache[key];
					for (let i = 0, l = cachedCities.length; i < l; i++) {
						let cachedCity = cachedCities[i];
						if (cachedCity.geo.distanceFrom(newCity.geo) < 100) {
							// < 100 km
							// cachedCity.merge(c.attributes, geo);
							append = false;
							break;
						}
					}
				} else {
					citiesCache[key] = [];
				}
				if (append) {
					cities.push(newCity);
					citiesCache[key].push(newCity);
				}
			});
			citiesCache = null; // make sure to garbage-collect this "big" object (~same size as data and cities)
			Store.emit(actions.SET_CITIES, cities);
		});
});

// SET CONTAINING TO TRUE IF ids ARE SCREENINGS IDS AND YOU WANT THE THEATERS CONTAINING THEM
// Issue : we might request things multiple times since previous results aren't always loaded when we check again
Store.on(actions.EXTRA_THEATERS, (ids, containing) => {
	let store = Store.get();
	let showtimesState = store.showtimes;
	// Find theaters containing the screenings with the specified id
	if (containing) {
		ids = ids.filter(id => id && !showtimesState.theaters.find(t => t.screenings.find(sc => sc.id === id)));
	} else { // Or theaters themselves with the specified id
		ids = ids.filter(id => id && !showtimesState.theaters.find(t => t.id === id));
	}
	if (!ids.length) {
		return;
	}

	// var loadingScreenings =
	// showtimesState.set({loading});

	getTheatersScreeningsAsync(store, ids, containing)
		.then(data => {
			if (data.errors && data.errors.length) {
				throw new Error(data.errors[0].detail);
			}
			// if (!data.data) {
			// 	throw new Error(NO_DATA);
			// }
			return processScreeningsApi(data, store.client.geo, store.appData, store.activePage, thMasters);
		})
		.then(({ theaters }) => {
			Store.emit(actions.ADD_THEATERS, theaters);
		})
		.catch(err => {
			track({ a: 'showtimes_request_error', l: err.message, ni: 1 });
			Store.emit(actions.API_ERROR, 'StData', err.message);
			console.log("showtimes_request_error", err);
		});
});

Store.on(actions.SELECT_TIME, (theater, screening) => {
	if (screening.provider_id === 'maccs') {
		track({ a: 'MACCS_SCREENING_CLICKED', l: theater.id });
	}
});

Store.on(actions.SELECT_SCREENING, ({ screening, theater }) => {
	// // Find the right theater
	// let theater = Store.get().showtimes.theaters.find((theater) => theater.id === theaterId);
	// set the screening for it
	theater.set({ activeScreening: screening });
});

Store.on(actions.SHOW_SCREENING_AUTH, ({ screening, theater }) => {
	// TODO: Maybe we should use activeScreening and check the authToken in the render
	const store = Store.get();
	if (screening) {
		if (store.user.authToken) {
			Store.emit(actions.SELECT_SCREENING, { theater, screening });
			Store.emit(actions.OPEN_TICKETING, { theater, screening });
			return;
		}
		store.showtimes.theaters.forEach(t => {
			if (t !== theater && t.authScreening) {
				t.set({ authScreening: null });
			}
		});
	}
	theater.set({ authScreening: screening });
});

Store.on(actions.AUTH_RESPONSE, data => {
	const token = data && data.token;
	Store.get().user.set({ authToken: data && data.token });
	if (token) {
		let theater = Store.get().showtimes.theaters.find((theater) => theater.active && theater.authScreening);
		if (theater) {
			const screening = theater.authScreening;
			theater = theater.set({ authScreening: null, activeScreening: screening });
			Store.emit(actions.OPEN_TICKETING, { theater: theater, screening: screening });
		}
	}
});

Store.on(actions.AUTH_CLEAR, () => {
	Store.get().user.remove('authToken');
});
